import { IFI as IFIModule } from '../../CIMSModule/instances'
import { CIMSPage } from '../../cimsPage'
import { Permission } from '../../permission'
import { RoleTemplateItem } from '../RoleTemplateItem'

const IFI = 'Identified Field Issue'

export const IFIReviewer = new RoleTemplateItem({
  id: '13025c61-e40f-42c6-95a7-6325f959a41b',
  name: `${IFI} Reviewer`,
  description: `Allows users to review ${IFI}s and advance the issue or close the issue`,
  module: IFIModule,
  permissionItems: [
    ...Permission.findByPage(CIMSPage.IFITracker),
    Permission.ViewIssue,
    Permission.CreateIssue,
    Permission.CommentOnIssue,
    Permission.ViewIssueType,
    Permission.ViewIssueDispositionType,
    Permission.ViewIssueQuickLink,
    Permission.ViewIssueNotification,
    ...Permission.findByPage(CIMSPage.IFINotifications),
  ],
})
